import {FileTableConfiguration} from './FileTableConfiguration';
import {XlsConfiguration} from '../../file/message/XlsConfiguration';

export class TableToFileConfiguration extends FileTableConfiguration {
exitStatusOnNoObtainedData: boolean | null;
exitStatusOnObtainedData: boolean | null;
fastCsv: boolean | null;
fastXls: boolean | null;
fastXml: boolean | null;
partitionFieldName: string;
recordsFromConnectIn: boolean | null;
rootFieldName: string;
xlsConfiguration: XlsConfiguration;
}

